<template>
  <div>
    <transition name="slide">
      <div class="cm-confirm-container" :style="{'z-index': index}" v-if="show">
        <div class="cm-confirm-box">
          <h3>{{title}}</h3>
          <p class="cm-confirm-label">{{text}}</p>
            <v-btn @click="show = false">cancel</v-btn>
            <v-btn style="float: right" @click="confirm" color="primary">confirm</v-btn>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => `Cancel?`
    },
    text: {
      type: String,
      default: () => `Are you sure?`
    },
    action: {
      type: Function,
      default: () => true
    },
    index: {
      type: Number,
      default: () => 5
    }
  },

  data () {
    return {
      show: false,
    }
  },

  watch: {
    // when the action is set, we show the view to see if the user wants to confirm the action
    action() {
      this.show = true
    }
  },

  methods: {
    // if the use clicks confirm, we execute the stored action then hide the form
    confirm () {
      this.action()
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-confirm-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: rgba(0,0,0,0.2);
  transition: all .2s;

  .cm-confirm-box {
    padding: 20px;
    background: white;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);

    h3 {
      margin-top: 0;
    }

    .cm-confirm-label {
      color: #aaa;
      letter-spacing: 0.07em;;
      width: 300px;
    }

    .cm-confirm-buttons {
      width: 300px;
    }
  }
}
</style>